import { Redirect } from 'expo-router';

export default function UserIntegrationsRedirect() {
  return <Redirect href="/app/settings/integrations" />;
}
